export const parsePercentageToApiFormat = (value: string | number): string => {
  if (+value === 0) {
    return '0.000';
  }

  return (+value / 100).toFixed(3);
};

export const parseApiFormatToPercentage = (value: string): string => (+value * 100).toFixed(1);
